// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {};

export const quizResponseSlice = createSlice({
  name: 'quizResponse',
  initialState,
  reducers: {},
});

export const {} = quizResponseSlice.actions;

export default quizResponseSlice.reducer;
